type TotalRowCountParams = {
  dataLength: number;
  hasNextPage: boolean;
  isPlaceholderData: boolean;
  page: number;
  pageSize: number;
};

export function getTotalRowCount({
  dataLength,
  hasNextPage,
  isPlaceholderData,
  page,
  pageSize,
}: TotalRowCountParams) {
  if (isPlaceholderData) {
    return (page + 1) * pageSize;
  }

  return hasNextPage ? (page + 2) * pageSize : page * pageSize + dataLength;
}
